import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "react-modal";
import { toast, ToastContainer } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import { validateToken } from "../tokenValidation";
import { FaArrowLeft } from "react-icons/fa";
import { Dialog } from "primereact/dialog";
import secureStorage from "../utils/secureStorage";
const Viewdoctor = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const API_URL = process.env.REACT_APP_API_URL;
    const data = location.state?.data;
    const [visible, setVisible] = useState(false);
    const [consents, setConsents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedPractitioner, setSelectedPractitioner] = useState("");
    const [practitioners, setPractitioners] = useState([]);

    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [expireDate, setExpireDate] = useState("");
    const [purpose, setPurpose] = useState("");
    const [selectedConsent, setSelectedConsent] = useState(null);
    const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
    const [consentDetails, setConsentDetails] = useState([]);
    const [detailsLoading, setDetailsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [activeTab, setActiveTab] = useState("requested");
    const [isSubmittingConsent, setIsSubmittingConsent] = useState(false);
    const [subCentres, setSubCentres] = useState([]);
    const [selectedSubCentre, setSelectedSubCentre] = useState("");

    const allHealthInfoTypes = [
        { code: "WellnessRecord", display: "Wellness Record" },
        { code: "Prescription", display: "Prescription" },
        { code: "DiagnosticReport", display: "Diagnostic Report" },
        { code: "OPConsultation", display: "OP Consultation" },
        { code: "DischargeSummary", display: "Discharge Summary" },
        { code: "ImmunizationRecord", display: "Immunization Record" },
        { code: "HealthDocumentRecord", display: "Record Artifact" },
        { code: "Invoice", display: "Invoice" },
    ];
    const [healthInfoTypes, setHealthInfoTypes] = useState(() =>
        allHealthInfoTypes.map((t) => t.code)
    );
    const initialHealthInfoTypes = allHealthInfoTypes.map(t => t.code);
    const resetForm = () => {
        setSelectedPractitioner("");
        setPurpose("");
        setFromDate("");
        setToDate("");
        setExpireDate("");
        setHealthInfoTypes(initialHealthInfoTypes);
        setSelectedSubCentre("");
    };

    const fetchSubcentres = async () => {
        try {
            const token = secureStorage.get("authToken");
            const clinicId = secureStorage.get("clinic");
            const orgId = secureStorage.get("orgId");

            const resp = await fetch(
                `${API_URL}hospital/get-subcentres?orgId=${encodeURIComponent(orgId)}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "X-HIP-ID": clinicId,
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (!resp.ok) throw new Error("Failed to fetch subcentres");
            const json = await resp.json();
            const facilities = json.data?.facilityDetails || [];
            setSubCentres(facilities);

            // Auto-select if only one facility
            if (facilities.length === 1) {
                setSelectedSubCentre(facilities[0].hipId);
            }
        } catch (e) {
            console.error("Error fetching subcentres:", e);
            toast.error("Error fetching organizations.");
        }
    };

    function formatDate(dateString) {
        const options = {
            year: 'numeric',
            month: 'short',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        };

        const date = new Date(dateString);
        return date.toLocaleString('en-US', options);
    }

    function formatOnlyDate(dateString) {
        const options = {
            year: 'numeric',
            month: 'short',
            day: '2-digit'
        };

        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', options);
    }

    // New state for expanded HIPs
    const [expandedHIPs, setExpandedHIPs] = useState([]);

    // Toggle function
    const toggleHIP = (index) => {
        setExpandedHIPs((prev) => {
            if (prev.includes(index)) {
                return prev.filter((i) => i !== index);
            } else {
                return [...prev, index];
            }
        });
    };

    // Function to fetch consent details
    const fetchConsentDetails = async (consent) => {
        console.log(consent, "CONSETT");
        try {
            const token = secureStorage.get("authToken");
            const clinicId = secureStorage.get("clinic");
            if (!token) {
                console.error("Authentication token not found. Please log in again.");
                toast.error("Authentication token not found. Please log in again.");
                return;
            }


            setDetailsLoading(true); // Start loading

            const response = await fetch(
                `${API_URL}hospital/get-consent-details?requestId=${consent.requestId}`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                        "X-HIP-ID": clinicId
                    },
                }
            );

            if (response.ok) {
                const data = await response.json();
                setConsentDetails(data.data || []);
                console.log("Consent Details:", data.data);
            } else {
                console.error("Failed to fetch Consent Details:", response.statusText);
                toast.error("Failed to fetch Consent Details.");
            }
        } catch (error) {
            console.error("Error fetching Consent Details:", error);
            toast.error("Error fetching Consent Details.");
        } finally {
            setDetailsLoading(false); // End loading
        }
    };

    const handleViewDetails = async (consent) => {
        setSelectedConsent(consent);

        if (consent.requestId) {
            setIsDetailsModalOpen(true);
            await fetchConsentDetails(consent);
        }
    };

    const closeDetailsModal = () => {
        setActiveTab("requested")
        setSelectedConsent(null);
        setConsentDetails([]);
        setIsDetailsModalOpen(false);
        setExpandedHIPs([]);
    };

    useEffect(() => {
        validateToken(navigate);
    }, [navigate]);

    useEffect(() => {
        if (data?.abhaNumber) {
            fetchConsents(data.preferredAbhaAddress, currentPage, pageSize);
        }
        fetchPractitioners();
        fetchSubcentres();
    }, [data, currentPage, pageSize]);

    const fetchPractitioners = async () => {
        try {
            const token = secureStorage.get("authToken");
            const clinicId = secureStorage.get("clinic");
            const orgId = secureStorage.get("orgId");
            if (!token) {
                console.error("Authentication token not found. Please log in again.");
                return;
            }

            const response = await fetch(
                `${API_URL}hospital/get-active-practitioners?orgId=${orgId}`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                        "X-HIP-ID": clinicId,
                    },
                }
            );

            if (response.ok) {
                const data = await response.json();
                setPractitioners(data.data || []);
            } else {
                console.error("Failed to fetch practitioners:", response.statusText);
                toast.error("Failed to fetch practitioners.");
            }
        } catch (error) {
            console.error("Error fetching practitioners:", error);
            toast.error("Error fetching practitioners.");
        }
    };

    const fetchConsents = async (abhaNumber, pageNumber, pageSize) => {
        try {
            const token = secureStorage.get("authToken");
            const clinicId = secureStorage.get("clinic");
            const orgId = secureStorage.get("orgId");
            if (!token) {
                console.error("Authentication token not found. Please log in again.");
                return;
            }

            const response = await fetch(
                `${API_URL}hospital/get-consent-requests?abhaAddress=${abhaNumber}&orgId=${encodeURIComponent(orgId)}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                        "X-HIP-ID": clinicId,
                    },
                }
            );

            if (response.ok) {
                const responseData = await response.json();
                setConsents(responseData.data.content || []);
                setTotalPages(responseData.data.totalPages || 0);
            } else {
                console.error("Failed to fetch consents", response.statusText);
                toast.error("Failed to fetch consents.");
            }
        } catch (error) {
            console.error("Error fetching consents:", error);
            toast.error("Error fetching consents.");
        } finally {
            setLoading(false);
        }
    };

    const handleRequestConsent = async () => {
        const now = new Date();
        const from = new Date(fromDate);
        const to = new Date(toDate);
        const expire = new Date(expireDate);

        if (from > now) {
            alert("Health Info From date must be a past date.");
            return;
        }
        if (to > now) {
            alert("Health Info To date must be a past date.");
            return;
        }
        if (expire <= now) {
            alert("Consent Expiry date must be a future date.");
            return;
        }
        setIsSubmittingConsent(true);
        try {
            const token = secureStorage.get("authToken");
            const clinicId = secureStorage.get("clinic");
            if (!token) {
                console.error("Authentication token not found. Please log in again.");
                toast.error("Authentication token not found. Please log in again.");
                return;
            }

            const payload = {
                abhaAddress: data?.preferredAbhaAddress,
                abhaNumber: data?.abhaNumber,
                doctorId: selectedPractitioner,
                hiTypes: healthInfoTypes,
                purpose: purpose,
                fromDate: from.toISOString(),
                toDate: to.toISOString(),
                expireDate: expire.toISOString(),
                hipId: selectedSubCentre,
            };

            const response = await fetch(`${API_URL}hospital/consent-request`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                    "X-HIP-ID": clinicId,
                },
                body: JSON.stringify(payload),
            });

            if (response.ok) {
                toast.success("Consent requested successfully.");
                resetForm();
                setTimeout(() => {
                    fetchConsents(data?.preferredAbhaAddress, 0, 10);
                }, 3000);
                setIsModalOpen(false);
            } else {
                console.error("Failed to request consent:", response.statusText);
                toast.error("Failed to request consent.");
            }
        } catch (error) {
            console.error("Error requesting consent:", error);
            toast.error("Error requesting consent.");
        } finally {
            setIsSubmittingConsent(false);
        }
    };

    const handleRefreshConsentStatus = async (consentRequestId) => {
        const requestId = uuidv4();
        const maxAttempts = 5;
        let attempts = 0;

        const token = secureStorage.get("authToken");
        const clinicId = secureStorage.get("clinic");
        if (!token) {
            console.error("Authentication token not found. Please log in again.");
            toast.error("Authentication token not found. Please log in again.");
            return;
        }

        const fetchStatus = async () => {
            try {
                const response = await fetch(
                    `${API_URL}hospital/consent-request-status?consentRequestId=${consentRequestId}&requestId=${requestId}`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                            "X-HIP-ID": clinicId,
                        },
                    }
                );

                if (response.ok) {
                    const responseData = await response.json();
                    console.log("Consent request status:", responseData);

                    if (responseData.data.statusUpdated) {
                        toast.success(
                            `Consent Status Updated: ${responseData.data.status}`
                        );
                        fetchConsents(data?.preferredAbhaAddress, 0, 10);
                        clearInterval(pollingInterval);
                    } else {
                        attempts++;
                        if (attempts >= maxAttempts) {
                            console.warn("Max attempts reached. Stopping polling.");
                            toast.warn(
                                "Failed to update consent status within the time limit."
                            );
                            clearInterval(pollingInterval);
                        }
                    }
                } else {
                    console.error(
                        "Failed to fetch consent request status:",
                        response.statusText
                    );
                    toast.error("Failed to fetch consent request status.");
                    clearInterval(pollingInterval);
                }
            } catch (error) {
                console.error("Error fetching consent request status:", error);
                toast.error("Error fetching consent request status.");
                clearInterval(pollingInterval);
            }
        };

        const pollingInterval = setInterval(fetchStatus, 2000);

        fetchStatus();
    };

    function formatReadableDate(dateStr) {
        if (!dateStr) return "-";
        const date = new Date(dateStr);
        return date.toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        }).replace(",", "");
    }

    const handlePageChange = (page) => {
        if (page >= 0 && page < totalPages) {
            setCurrentPage(page);
        }
    };

    const handleViewRecord = (record) => {
        navigate(`/abhaRecords?queryParam=${record}`);
    };

    return (
        <>
            <Dialog
                header="Header"
                visible={visible}
                style={{ width: "50vw" }}
                onHide={() => {
                    if (!visible) return;
                    setVisible(false);
                }}
            >
                <p className="m-0">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
                    minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                    aliquip ex ea commodo consequat. Duis aute irure dolor in
                    reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                    pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                    culpa qui officia deserunt mollit anim id est laborum.
                </p>
            </Dialog>
            <div className="bg-[#F6F6F6] min-h-screen p-6">
                <div className="flex items-center justify-between mb-6 relative">
                    <button
                        onClick={() => navigate(-1)}
                        className="absolute left-0 flex items-center text-teal-700 hover:text-teal-900 font-medium"
                    >
                        <FaArrowLeft className="mr-2" /> Back
                    </button>

                    <h1 className="w-full text-center text-3xl font-bold text-gray-800">Consents</h1>
                </div>

                <div
                    className="rounded-lg overflow-hidden shadow-md"
                    style={{ backgroundColor: "#DEEBEC" }}
                >
                    <div className="flex justify-between items-center px-4 pt-2">
                        <h2 className="text-lg font-bold text-[#0F766E]">
                            Consent Details of {`${data.firstName || ""} ${data.middleName || ""} ${data.lastName || ""
                                }`.trim()}{" "}
                        </h2>
                        <button
                            className="bg-[#0F766E] text-white px-6 py-2 mt-2 rounded-md hover:bg-teal-700"
                            onClick={() => setIsModalOpen(true)}
                        >
                            New Consent Request
                        </button>
                    </div>
                    <p className="italic px-4 pb-4">(To view more details click on <b>View Details</b>)</p>

                    {loading ? (
                        <p className="text-center py-6">Loading...</p>
                    ) : (
                        <table className="w-full table-auto">
                            <thead className="bg-[#DEEBEC] border-b border-[#0F766E]">
                                <tr>
                                    <th className="px-4 py-3 text-left text-[15px] font-semibold text-[#0F766E]">
                                        Sl No
                                    </th>
                                    <th className="px-4 py-3 text-left text-[15px] font-semibold text-[#0F766E]">
                                        Patient Name
                                    </th>
                                    <th className="px-4 py-3 text-left text-[15px] font-semibold text-[#0F766E]">
                                        ABHA Address
                                    </th>
                                    <th className="px-4 py-3 text-left text-[15px] font-semibold text-[#0F766E]">
                                        Requested By
                                    </th>
                                    <th className="px-4 py-3 text-left text-[15px] font-semibold text-[#0F766E]">
                                        Requested Time
                                    </th>
                                    <th className="px-4 py-3 text-left text-[15px] font-semibold text-[#0F766E]">
                                        Request Status
                                    </th>
                                    <th className="px-4 py-3 text-center text-[15px] font-semibold text-[#0F766E]">
                                        View Details
                                    </th>
                                    <th className="px-4 py-3 text-center text-[15px] font-semibold text-[#0F766E]">
                                        View Health Recods
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {consents.map((consent, index) => (
                                    <tr key={consent.id}>
                                        <td className="px-4 py-3 text-sm font-medium text-gray-700">
                                            {index + 1}
                                        </td>
                                        <td className="px-4 py-3 text-sm font-medium text-gray-700">
                                            {`${data.firstName || ""} ${data.middleName || ""} ${data.lastName || ""
                                                }`.trim()}{" "}
                                        </td>
                                        <td className="px-4 py-3 text-sm font-medium text-gray-700">
                                            {consent?.patient?.id || "-"}
                                        </td>
                                        <td className="px-4 py-3 text-sm font-medium text-gray-700">
                                            {consent?.requester?.name || "-"}
                                        </td>
                                        <td className="px-4 py-3 text-sm font-medium text-gray-700">
                                            {formatReadableDate(consent?.createdDate)}
                                        </td>

                                        <td className="px-4 py-3 text-sm font-medium text-gray-700">
                                            <div className="flex items-center space-x-4">
                                                <span
                                                    className={`flex justify-center items-center px-3 py-1 text-sm font-medium rounded-full text-white w-24 ${consent.consentStatus === "GRANTED"
                                                        ? "bg-green-500"
                                                        : consent.consentStatus === "REQUESTED"
                                                            ? "bg-orange-500"
                                                            : consent.consentStatus === "DENIED"
                                                                ? "bg-red-500"
                                                                : consent.consentStatus === "REVOKED"
                                                                    ? "bg-yellow-500"
                                                                    : "bg-gray-400"
                                                        }`}
                                                >
                                                    {consent.consentStatus || "-"}
                                                </span>
                                                {(consent.consentStatus === "GRANTED" ||
                                                    consent.consentStatus === "REQUESTED") && (
                                                        <button
                                                            onClick={() =>
                                                                handleRefreshConsentStatus(
                                                                    consent.consentRequestId
                                                                )
                                                            }
                                                            className="hover:bg-teal-700 text-teal-700 hover:text-white rounded-full p-2 border border-teal-700 w-10 h-10 flex justify-center items-center"
                                                            title="Refresh"
                                                        >
                                                            🔄
                                                        </button>
                                                    )}
                                            </div>
                                        </td>
                                        <td
                                            onClick={() => handleViewDetails(consent)}
                                            className="px-4 py-2 text-[#2B98D6] text-center font-medium hover:underline cursor-pointer"
                                        >
                                            View
                                        </td>
                                        {consent.consentStatus === "GRANTED" && (
                                            <td
                                                onClick={() =>
                                                    handleViewRecord(
                                                        consent.consentRequestId
                                                    )
                                                }
                                                className="px-4 py-2 text-[#2B98D6] text-center font-medium hover:underline cursor-pointer"
                                            >
                                                View Records
                                            </td>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>

                <div className="flex justify-between items-center mt-4">
                    <button
                        className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-400 disabled:opacity-50"
                        disabled={currentPage === 0}
                        onClick={() => handlePageChange(currentPage - 1)}
                    >
                        Previous
                    </button>
                    <span className="text-sm text-gray-700">
                        Page {currentPage + 1} of {totalPages}
                    </span>
                    <button
                        className="bg-teal-500 text-white px-4 py-2 rounded-md hover:bg-teal-600"
                        disabled={currentPage === totalPages - 1}
                        onClick={() => handlePageChange(currentPage + 1)}
                    >
                        Next
                    </button>
                </div>

                {/* New Consent Request Modal */}
                <Modal
                    isOpen={isModalOpen}
                    onRequestClose={() => setIsModalOpen(false)}
                    style={{
                        overlay: {
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                        },
                        content: {
                            maxWidth: "750px",
                            margin: "auto",
                            padding: "20px",
                            borderRadius: "10px",
                            fontFamily: "Arial, sans-serif",
                        },
                    }}
                >
                    <h2 className="text-lg font-bold text-[#0F766E] mb-4">
                        Consent Request Form
                    </h2>
                    <p className="text-sm text-red-500 mb-4">
                        All the fields are mandatory.
                    </p>
                    <div className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700">
                                Patient Identifier
                            </label>
                            <div className="flex items-center mt-1">
                                <div className="flex flex-col">
                                    <strong className="">
                                        <span className=""> Name -</span>{" "}
                                        {`${data.firstName || ""} ${data.middleName || ""} ${data.lastName || ""}`.trim()}
                                    </strong>
                                    <strong className="">
                                        <span className=""> ABHA Address - </span>
                                        {data.preferredAbhaAddress}
                                    </strong>
                                </div>
                            </div>
                        </div>

                        <div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700">
                                Select Organization
                            </label>
                            <select
                                value={selectedSubCentre}
                                onChange={(e) => setSelectedSubCentre(e.target.value)}
                                className="w-full border border-gray-300 p-2 rounded-md"
                            >
                                <option value="">Select Organization</option>
                                {subCentres.map((centre) => (
                                    <option
                                        key={centre.hipId}
                                        value={centre.hipId}
                                    >
                                        {centre.centerName}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700">
                                Select Practitioner
                            </label>
                            <select
                                value={selectedPractitioner}
                                onChange={(e) => setSelectedPractitioner(e.target.value)}
                                className="w-full border border-gray-300 p-2 rounded-md"
                            >
                                <option value="">Select Practitioner</option>
                                {practitioners.map((practitioner) => (
                                    <option
                                        key={practitioner.healthcareProfessionalId}
                                        value={practitioner.healthcareProfessionalId}
                                    >
                                        {practitioner.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">
                                Purpose of Request
                            </label>
                            <select
                                value={purpose}
                                onChange={(e) => setPurpose(e.target.value)}
                                className="w-full p-2 border border-gray-300 rounded-md"
                            >
                                <option value="" disabled>
                                    Select a Purpose
                                </option>
                                {[
                                    { code: "CAREMGT", display: "Care Management" },
                                    { code: "BTG", display: "Break the Glass" },
                                    { code: "PUBHLTH", display: "Public Health" },
                                    { code: "HPAYMT", display: "Healthcare Payment" },
                                    {
                                        code: "DSRCH",
                                        display: "Disease Specific Healthcare Research",
                                    },
                                    { code: "PATRQT", display: "Self Requested" },
                                ].map((option) => (
                                    <option key={option.code} value={option.code}>
                                        {option.display}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700">
                                    Health Info From
                                </label>
                                <input
                                    type="date"
                                    value={fromDate}
                                    onChange={(e) => setFromDate(e.target.value)}
                                    max={new Date().toISOString().split("T")[0]}
                                    className="w-full p-2 border border-gray-300 rounded-md"
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700">
                                    Health Info To
                                </label>
                                <input
                                    type="date"
                                    value={toDate}
                                    onChange={(e) => setToDate(e.target.value)}
                                    max={new Date().toISOString().split("T")[0]}
                                    className="w-full p-2 border border-gray-300 rounded-md"
                                />
                            </div>
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Health Info Type
                            </label>

                            <div className="flex justify-start mb-2">
                                <button
                                    className="text-xs bg-teal-600 text-white rounded-md hover:bg-teal-700 text-white px-3 py-1 rounded"
                                    onClick={() => {
                                        if (healthInfoTypes.length === allHealthInfoTypes.length) {
                                            setHealthInfoTypes([]);
                                        } else {
                                            setHealthInfoTypes(allHealthInfoTypes.map((t) => t.code));
                                        }
                                    }}
                                >
                                    {healthInfoTypes.length === allHealthInfoTypes.length
                                        ? "Deselect All" : "Select All"}
                                </button>
                            </div>

                            <div className="grid grid-cols-2 gap-2">
                                {allHealthInfoTypes.map((type) => (
                                    <label key={type.code} className="flex items-center space-x-2">
                                        <input
                                            type="checkbox"
                                            value={type.code}
                                            checked={healthInfoTypes.includes(type.code)}
                                            onChange={(e) => {
                                                const { value, checked } = e.target;
                                                setHealthInfoTypes((prev) =>
                                                    checked ? [...prev, value] : prev.filter((t) => t !== value)
                                                );
                                            }}
                                            className="h-4 w-4"
                                        />
                                        <span className="text-sm">{type.display}</span>
                                    </label>
                                ))}
                            </div>
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700">
                                Consent Expiry
                            </label>
                            <input
                                type="datetime-local"
                                value={expireDate}
                                onChange={(e) => setExpireDate(e.target.value)}
                                min={new Date().toISOString().slice(0, 16)}
                                className="w-full p-2 border border-gray-300 rounded-md"
                            />
                        </div>
                    </div>

                    <div className="flex justify-end mt-6">
                        <button
                            className="px-4 py-2 bg-gray-300 text-black rounded-md"
                            onClick={() => setIsModalOpen(false)}
                        >
                            Cancel
                        </button>
                        <button
                            className="ml-4 px-4 py-2 bg-teal-600 hover:bg-teal-700 text-white rounded-md flex items-center justify-center"
                            onClick={handleRequestConsent}
                            disabled={isSubmittingConsent}
                        >
                            {isSubmittingConsent ? (
                                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                            ) : (
                                "Request Consent"
                            )}
                        </button>
                    </div>
                </Modal>
                {/* Consent Details Modal */}
                {consentDetails && (
                    <Modal
                        isOpen={isDetailsModalOpen}
                        onRequestClose={closeDetailsModal}
                        style={{
                            overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
                            content: {
                                maxWidth: "800px",
                                maxHeight: "90vh",
                                overflowY: "auto",
                                margin: "auto",
                                padding: "20px",
                                borderRadius: "15px",
                                fontFamily: "Arial, sans-serif",
                                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)",
                            },
                        }}
                        ariaHideApp={false}
                    >
                        <div className="flex justify-between items-center mb-6">
                            <h2 className="text-2xl font-bold text-[#0F766E]">
                                Consent Request {consentDetails.currentStatus}
                            </h2>
                            <button
                                onClick={closeDetailsModal}
                                className="text-red-500 hover:text-red-700 text-xl"
                                title="Close"
                            >
                                &times;
                            </button>
                        </div>

                        {/* Tab Navigation */}
                        <div className="border-b">
                            <ul className="flex space-x-4 text-sm font-medium text-gray-500">
                                {consentDetails.currentStatus === "REQUESTED" && (
                                    <>
                                        <li
                                            onClick={() => setActiveTab("requested")}
                                            className={`cursor-pointer px-4 py-2 rounded-t-lg ${activeTab === "requested"
                                                ? "bg-[#E6F4EA] text-[#0F766E] border-b-2 border-[#0F766E]"
                                                : "hover:bg-[#F9F9F9]"
                                                }`}
                                        >
                                            Requested Details
                                        </li>
                                    </>
                                )}
                                {consentDetails.currentStatus === "GRANTED" && (
                                    <>
                                        <li
                                            onClick={() => setActiveTab("requested")}
                                            className={`cursor-pointer px-4 py-2 rounded-t-lg ${activeTab === "requested"
                                                ? "bg-[#E6F4EA] text-[#0F766E] border-b-2 border-[#0F766E]"
                                                : "hover:bg-[#F9F9F9]"
                                                }`}
                                        >
                                            Requested Details
                                        </li>
                                        <li
                                            onClick={() => setActiveTab("granted")}
                                            className={`cursor-pointer px-4 py-2 rounded-t-lg ${activeTab === "granted"
                                                ? "bg-[#E6F4EA] text-[#0F766E] border-b-2 border-[#0F766E]"
                                                : "hover:bg-[#F9F9F9]"
                                                }`}
                                        >
                                            Granted Details
                                        </li>
                                    </>
                                )}
                                {consentDetails.currentStatus === "EXPIRED" && (
                                    <>
                                        <li
                                            onClick={() => setActiveTab("requested")}
                                            className={`cursor-pointer px-4 py-2 rounded-t-lg ${activeTab === "requested"
                                                ? "bg-[#E6F4EA] text-[#0F766E] border-b-2 border-[#0F766E]"
                                                : "hover:bg-[#F9F9F9]"}`}
                                        >
                                            Requested Details
                                        </li>

                                        {consentDetails.grantedDateTime && (
                                            <li
                                                onClick={() => setActiveTab("granted")}
                                                className={`cursor-pointer px-4 py-2 rounded-t-lg ${activeTab === "granted"
                                                    ? "bg-[#E6F4EA] text-[#0F766E] border-b-2 border-[#0F766E]"
                                                    : "hover:bg-[#F9F9F9]"}`}
                                            >
                                                Granted Details
                                            </li>
                                        )}

                                        {consentDetails.grantedDateTime && (
                                            <li
                                                onClick={() => setActiveTab("expired")}
                                                className={`cursor-pointer px-4 py-2 rounded-t-lg ${activeTab === "expired"
                                                    ? "bg-[#E6F4EA] text-[#0F766E] border-b-2 border-[#0F766E]"
                                                    : "hover:bg-[#F9F9F9]"}`}
                                            >
                                                Expired Details
                                            </li>
                                        )}

                                    </>
                                )}

                                {consentDetails.currentStatus === "REVOKED" && (
                                    <>
                                        <li
                                            onClick={() => setActiveTab("requested")}
                                            className={`cursor-pointer px-4 py-2 rounded-t-lg ${activeTab === "requested"
                                                ? "bg-[#E6F4EA] text-[#0F766E] border-b-2 border-[#0F766E]"
                                                : "hover:bg-[#F9F9F9]"
                                                }`}
                                        >
                                            Requested Details
                                        </li>
                                        <li
                                            onClick={() => setActiveTab("granted")}
                                            className={`cursor-pointer px-4 py-2 rounded-t-lg ${activeTab === "granted"
                                                ? "bg-[#E6F4EA] text-[#0F766E] border-b-2 border-[#0F766E]"
                                                : "hover:bg-[#F9F9F9]"
                                                }`}
                                        >
                                            Granted Details
                                        </li>
                                        <li
                                            onClick={() => setActiveTab("revoked")}
                                            className={`cursor-pointer px-4 py-2 rounded-t-lg ${activeTab === "revoked"
                                                ? "bg-[#E6F4EA] text-[#0F766E] border-b-2 border-[#0F766E]"
                                                : "hover:bg-[#F9F9F9]"
                                                }`}
                                        >
                                            Revoked Details
                                        </li>
                                    </>
                                )}
                                {consentDetails.currentStatus === "DENIED" && (
                                    <>
                                        <li
                                            onClick={() => setActiveTab("requested")}
                                            className={`cursor-pointer px-4 py-2 rounded-t-lg ${activeTab === "requested"
                                                ? "bg-[#E6F4EA] text-[#0F766E] border-b-2 border-[#0F766E]"
                                                : "hover:bg-[#F9F9F9]"
                                                }`}
                                        >
                                            Requested Details
                                        </li>
                                        <li
                                            onClick={() => setActiveTab("denied")}
                                            className={`cursor-pointer px-4 py-2 rounded-t-lg ${activeTab === "denied"
                                                ? "bg-[#E6F4EA] text-[#0F766E] border-b-2 border-[#0F766E]"
                                                : "hover:bg-[#F9F9F9]"
                                                }`}
                                        >
                                            Denied Details
                                        </li>
                                    </>
                                )}
                            </ul>
                        </div>



                        <div className="mt-1">
                            {/* Requested Tab */}
                            {activeTab === "requested" && (
                                <div className="space-y-4">
                                    <div className="grid grid-cols-1 gap-4 bg-[#f9f9f9] p-4 rounded-md shadow-md">
                                        {/* Requested Details */}
                                        <div className="bg-[#f2f4f5] p-3 rounded-md border border-[#d1d5db]">
                                            <h3 className="text-base font-semibold text-[#0F766E] mb-2">Requested Details</h3>
                                            <p className="text-sm text-gray-800 py-1">
                                                <strong>Requested By:</strong> {consentDetails.requestedByName || "-"}
                                            </p>
                                            <p className="text-sm text-gray-800 py-1">
                                                <strong>Requested At:</strong> {consentDetails.requestedDateTime ? formatDate(consentDetails.requestedDateTime) : "-"}
                                            </p>
                                            <p className="text-sm text-gray-800 py-1">
                                                <strong>Valid From:</strong> {consentDetails.requestedValidFrom ? formatOnlyDate(consentDetails.requestedValidFrom) : "-"}
                                            </p>
                                            <p className="text-sm text-gray-800 py-1">
                                                <strong>Valid To:</strong> {consentDetails.requestedValidTo ? formatOnlyDate(consentDetails.requestedValidTo) : "-"}
                                            </p>
                                            <p className="text-sm text-gray-800 py-1">
                                                <strong>Expire Date Time:</strong> {consentDetails.requestedExpireDate ? formatDate(consentDetails.requestedExpireDate) : "-"}
                                            </p>

                                            <div>
                                                <strong className="text-sm text-gray-700">Requested HI Types:</strong>
                                                <div className="flex flex-wrap gap-2 mt-1">
                                                    {consentDetails.requestedHiTypes?.map((type, idx) => (
                                                        <span
                                                            key={idx}
                                                            className="px-2 py-1 bg-[#E6F4EA] text-[#0F766E] border border-[#0F766E] rounded-full text-xs font-medium"
                                                        >
                                                            {type}
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Granted Tab */}
                            {activeTab === "granted" && (
                                <div className="space-y-4">
                                    <div className="grid grid-cols-1 gap-4 bg-[#f9f9f9] p-4 rounded-md shadow-md">
                                        {/* Granted Details */}
                                        <div className="bg-[#f2f4f5] p-3 rounded-md border border-[#d1d5db]">
                                            <h3 className="text-base font-semibold text-[#0F766E] mb-2">Granted Details</h3>
                                            <p className="text-sm text-gray-800 py-1">
                                                <strong>Requested By:</strong> {consentDetails.requestedByName || "-"}
                                            </p>
                                            <p className="text-sm text-gray-800 py-1">
                                                <strong>Granted At:</strong> {consentDetails.grantedDateTime ? formatDate(consentDetails.grantedDateTime) : "-"}
                                            </p>
                                            <p className="text-sm text-gray-800 py-1">
                                                <strong>Valid From:</strong> {consentDetails.grantedValidFrom ? formatOnlyDate(consentDetails.grantedValidFrom) : "-"}
                                            </p>
                                            <p className="text-sm text-gray-800 py-1">
                                                <strong>Valid To:</strong> {consentDetails.grantedValidTo ? formatOnlyDate(consentDetails.grantedValidTo) : "-"}
                                            </p>
                                            <p className="text-sm text-gray-800 py-1">
                                                <strong>Expire Date Time:</strong> {consentDetails.grantedExpireDate ? formatDate(consentDetails.grantedExpireDate) : "-"}
                                            </p>

                                            <div>
                                                <strong className="text-sm text-gray-700">Granted HI Types:</strong>
                                                <div className="flex flex-wrap gap-2 mt-1">
                                                    {consentDetails.grantedHiTypes?.map((type, idx) => (
                                                        <span
                                                            key={idx}
                                                            className="px-2 py-1 bg-[#E6F4EA] text-[#0F766E] border border-[#0F766E] rounded-full text-xs font-medium"
                                                        >
                                                            {type}
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>

                                            {/* HIP Details Table */}
                                            <div className="mt-3">
                                                <strong className="text-sm text-gray-700 py-1">HIP Details:</strong>
                                                {consentDetails.hipDetails && consentDetails.hipDetails.length > 0 ? (
                                                    <div>
                                                        {consentDetails.hipDetails.map((detail, index) => (
                                                            <div key={index} className="py-1">
                                                                <span
                                                                    onClick={() => toggleHIP(index)}
                                                                    className={`cursor-pointer flex items-center px-2 py-2 ${expandedHIPs.includes(index)
                                                                        ? "bg-[#0F766E] text-white" // Expanded state styling
                                                                        : "bg-[#0F766E] text-white"
                                                                        } rounded-full text-xs font-medium`}
                                                                    title="Click to toggle Care Contexts"
                                                                >
                                                                    {detail.hiu || "-"}
                                                                    <svg
                                                                        className={`ml-2 transition-transform duration-200 transform ${expandedHIPs.includes(index) ? "rotate-180" : "rotate-0"
                                                                            }`}
                                                                        width="12"
                                                                        height="12"
                                                                        viewBox="0 0 20 20"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            fill="currentColor"
                                                                            d="M14.707 7.707a1 1 0 0 0-1.414 0L10 11.586l-3.293-3.293a1 1 0 0 0-1.414 1.414l4 4a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0 0-1.414z"
                                                                        />
                                                                    </svg>
                                                                </span>

                                                                {/* If this HIP is expanded, show the care contexts */}
                                                                {expandedHIPs.includes(index) && (
                                                                    <table className="w-full mt-2 table-auto border border-collapse">
                                                                        <thead>
                                                                            <tr className="bg-[#f9fafb]">
                                                                                <th className="border border-gray-300 px-4 py-2 text-sm text-gray-700">
                                                                                    Patient Reference
                                                                                </th>
                                                                                <th className="border border-gray-300 px-4 py-2 text-sm text-gray-700">
                                                                                    Care Context Reference
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {detail.grantedCareContexts?.map((context, ctxIndex) => (
                                                                                <tr key={ctxIndex} className="text-center">
                                                                                    <td className="border border-gray-300 px-4 py-2 text-sm text-gray-700">
                                                                                        {context.patientReference || "-"}
                                                                                    </td>
                                                                                    <td className="border border-gray-300 px-4 py-2 text-sm text-gray-700">
                                                                                        {context.careContextReference || "-"}
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <p className="text-sm text-gray-700">No HIP details available.</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {activeTab === "revoked" && (
                                <div className="space-y-4">
                                    <div className="grid grid-cols-1 gap-4 bg-[#f9f9f9] p-4 rounded-md shadow-md">
                                        {/* Revoked Details */}
                                        <div className="bg-[#f2f4f5] p-3 rounded-md border border-[#d1d5db]">
                                            <h3 className="text-base font-semibold text-[#0F766E] mb-2">Revoked Details</h3>
                                            <p className="text-sm text-gray-800 py-1">
                                                <strong>Requested By:</strong> {consentDetails.requestedByName || "-"}
                                            </p>
                                            <p className="text-sm text-gray-800 py-1">
                                                <strong>Granted At:</strong> {consentDetails.grantedDateTime ? formatDate(consentDetails.grantedDateTime) : "-"}
                                            </p>
                                            <p className="text-sm text-gray-800 py-1">
                                                <strong>Valid From:</strong> {consentDetails.grantedValidFrom ? formatOnlyDate(consentDetails.grantedValidFrom) : "-"}
                                            </p>
                                            <p className="text-sm text-gray-800 py-1">
                                                <strong>Valid To:</strong> {consentDetails.grantedValidTo ? formatOnlyDate(consentDetails.grantedValidTo) : "-"}
                                            </p>
                                            <p className="text-sm text-gray-800 py-1">
                                                <strong>Expire Date Time:</strong> {consentDetails.grantedExpireDate ? formatDate(consentDetails.grantedExpireDate) : "-"}
                                            </p>
                                            <p className="text-sm text-gray-800 py-1">
                                                <strong>Revoked Date Time:</strong> {consentDetails.revokedDateTime ? formatDate(consentDetails.revokedDateTime) : "-"}
                                            </p>

                                            <div>
                                                <strong className="text-sm text-gray-700">Granted HI Types:</strong>
                                                <div className="flex flex-wrap gap-2 mt-1">
                                                    {consentDetails.grantedHiTypes?.map((type, idx) => (
                                                        <span
                                                            key={idx}
                                                            className="px-2 py-1 bg-[#E6F4EA] text-[#0F766E] border border-[#0F766E] rounded-full text-xs font-medium"
                                                        >
                                                            {type}
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>

                                            {/* HIP Details Table */}
                                            <div className="mt-3">
                                                <strong className="text-sm text-gray-700">HIP Details:</strong>
                                                {consentDetails.hipDetails && consentDetails.hipDetails.length > 0 ? (
                                                    <div>
                                                        {consentDetails.hipDetails.map((detail, index) => (
                                                            <div key={index} className="py-1">
                                                                <span
                                                                    onClick={() => toggleHIP(index)}
                                                                    className={`cursor-pointer flex items-center px-2 py-2 ${expandedHIPs.includes(index)
                                                                        ? "bg-[#0F766E] text-white" // Expanded state styling
                                                                        : "bg-[#0F766E] text-white"
                                                                        } rounded-full text-xs font-medium`}
                                                                    title="Click to toggle Care Contexts"
                                                                >
                                                                    {detail.hiu || "-"}
                                                                    <svg
                                                                        className={`ml-2 transition-transform duration-200 transform ${expandedHIPs.includes(index) ? "rotate-180" : "rotate-0"
                                                                            }`}
                                                                        width="12"
                                                                        height="12"
                                                                        viewBox="0 0 20 20"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            fill="currentColor"
                                                                            d="M14.707 7.707a1 1 0 0 0-1.414 0L10 11.586l-3.293-3.293a1 1 0 0 0-1.414 1.414l4 4a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0 0-1.414z"
                                                                        />
                                                                    </svg>
                                                                </span>

                                                                {/* If this HIP is expanded, show the care contexts */}
                                                                {expandedHIPs.includes(index) && (
                                                                    <table className="w-full mt-2 table-auto border border-collapse">
                                                                        <thead>
                                                                            <tr className="bg-[#f9fafb]">
                                                                                <th className="border border-gray-300 px-4 py-2 text-sm text-gray-700">
                                                                                    Patient Reference
                                                                                </th>
                                                                                <th className="border border-gray-300 px-4 py-2 text-sm text-gray-700">
                                                                                    Care Context Reference
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {detail.grantedCareContexts?.map((context, ctxIndex) => (
                                                                                <tr key={ctxIndex} className="text-center">
                                                                                    <td className="border border-gray-300 px-4 py-2 text-sm text-gray-700">
                                                                                        {context.patientReference || "-"}
                                                                                    </td>
                                                                                    <td className="border border-gray-300 px-4 py-2 text-sm text-gray-700">
                                                                                        {context.careContextReference || "-"}
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <p className="text-sm text-gray-700">No HIP details available.</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Expired Tab */}
                            {activeTab === "expired" && (
                                <div className="space-y-4">
                                    <div className="grid grid-cols-1 gap-4 bg-[#f9f9f9] p-4 rounded-md shadow-md">
                                        {/* Expired Details */}
                                        <div className="bg-[#f2f4f5] p-3 rounded-md border border-[#d1d5db]">
                                            <h3 className="text-base font-semibold text-[#0F766E] mb-2">Expired Details</h3>
                                            <p className="text-sm text-gray-800 py-1">
                                                <strong>Requested By:</strong> {consentDetails.requestedByName || "-"}
                                            </p>
                                            <p className="text-sm text-gray-800 py-1">
                                                <strong>Granted At:</strong> {consentDetails.grantedDateTime ? formatDate(consentDetails.grantedDateTime) : "-"}
                                            </p>
                                            <p className="text-sm text-gray-800 py-1">
                                                <strong>Valid From:</strong> {consentDetails.grantedValidFrom ? formatOnlyDate(consentDetails.grantedValidFrom) : "-"}
                                            </p>
                                            <p className="text-sm text-gray-800 py-1">
                                                <strong>Valid To:</strong> {consentDetails.grantedValidTo ? formatOnlyDate(consentDetails.grantedValidTo) : "-"}
                                            </p>
                                            <p className="text-sm text-gray-800 py-1">
                                                <strong>Expire Date Time:</strong> {consentDetails.grantedExpireDate ? formatDate(consentDetails.grantedExpireDate) : "-"}
                                            </p>
                                            {/* <p className="text-sm text-gray-800 py-1">
                                                <strong>Expired Date Time:</strong> {consentDetails.expiredDateTime ? formatDate(consentDetails.expiredDateTime) : {consentDetails.grantedExpireDate ? formatDate(consentDetails.grantedExpireDate) : "-"}}
                                            </p> */}
                                            {/* <p className="text-sm text-gray-800 py-1">
                                                <strong>Expired Date:</strong>{" "}
                                                {consentDetails.expiredDateTime
                                                    ? formatDate(consentDetails.expiredDateTime)
                                                    : consentDetails.grantedExpireDate
                                                        ? formatDate(consentDetails.grantedExpireDate)
                                                        : "-"}
                                            </p> */}
                                            <p className="text-sm text-gray-800 py-1">
                                                <strong>Expired Date:</strong>{" "}
                                                {consentDetails.grantedExpireDate ? formatDate(consentDetails.grantedExpireDate) : "-"}
                                            </p>

                                            <div>
                                                <strong className="text-sm text-gray-700">Granted HI Types:</strong>
                                                <div className="flex flex-wrap gap-2 mt-1">
                                                    {consentDetails.grantedHiTypes?.map((type, idx) => (
                                                        <span
                                                            key={idx}
                                                            className="px-2 py-1 bg-[#E6F4EA] text-[#0F766E] border border-[#0F766E] rounded-full text-xs font-medium"
                                                        >
                                                            {type}
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>

                                            {/* HIP Details Table */}
                                            <div className="mt-3">
                                                <strong className="text-sm text-gray-700">HIP Details:</strong>
                                                {consentDetails.hipDetails && consentDetails.hipDetails.length > 0 ? (
                                                    <div>
                                                        {consentDetails.hipDetails.map((detail, index) => (
                                                            <div key={index} className="py-1">
                                                                <span
                                                                    onClick={() => toggleHIP(index)}
                                                                    className={`cursor-pointer flex items-center px-2 py-2 ${expandedHIPs.includes(index)
                                                                        ? "bg-[#0F766E] text-white" // Expanded state styling
                                                                        : "bg-[#0F766E] text-white"
                                                                        } rounded-full text-xs font-medium`}
                                                                    title="Click to toggle Care Contexts"
                                                                >
                                                                    {detail.hiu || "-"}
                                                                    <svg
                                                                        className={`ml-2 transition-transform duration-200 transform ${expandedHIPs.includes(index) ? "rotate-180" : "rotate-0"
                                                                            }`}
                                                                        width="12"
                                                                        height="12"
                                                                        viewBox="0 0 20 20"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            fill="currentColor"
                                                                            d="M14.707 7.707a1 1 0 0 0-1.414 0L10 11.586l-3.293-3.293a1 1 0 0 0-1.414 1.414l4 4a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0 0-1.414z"
                                                                        />
                                                                    </svg>
                                                                </span>

                                                                {/* If this HIP is expanded, show the care contexts */}
                                                                {expandedHIPs.includes(index) && (
                                                                    <table className="w-full mt-2 table-auto border border-collapse">
                                                                        <thead>
                                                                            <tr className="bg-[#f9fafb]">
                                                                                <th className="border border-gray-300 px-4 py-2 text-sm text-gray-700">
                                                                                    Patient Reference
                                                                                </th>
                                                                                <th className="border border-gray-300 px-4 py-2 text-sm text-gray-700">
                                                                                    Care Context Reference
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {detail.grantedCareContexts?.map((context, ctxIndex) => (
                                                                                <tr key={ctxIndex} className="text-center">
                                                                                    <td className="border border-gray-300 px-4 py-2 text-sm text-gray-700">
                                                                                        {context.patientReference || "-"}
                                                                                    </td>
                                                                                    <td className="border border-gray-300 px-4 py-2 text-sm text-gray-700">
                                                                                        {context.careContextReference || "-"}
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <p className="text-sm text-gray-700">No HIP details available.</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Denied Tab */}
                            {activeTab === "denied" && (
                                <div className="space-y-4">
                                    <div className="grid grid-cols-1 gap-4 bg-[#f9f9f9] p-4 rounded-md shadow-md">
                                        {/* Denied Details */}
                                        <div className="bg-[#f2f4f5] p-3 rounded-md border border-[#d1d5db]">
                                            <h3 className="text-base font-semibold text-[#0F766E] mb-2">Denied Details</h3>
                                            <p className="text-sm text-gray-800 py-1">
                                                <strong>Requested By:</strong> {consentDetails.requestedByName || "-"}
                                            </p>
                                            <p className="text-sm text-gray-800 py-1">
                                                <strong>Requested At:</strong> {consentDetails.requestedDateTime ? formatDate(consentDetails.requestedDateTime) : "-"}
                                            </p>
                                            <p className="text-sm text-gray-800 py-1">
                                                <strong>Valid From:</strong> {consentDetails.requestedValidFrom ? formatOnlyDate(consentDetails.requestedValidFrom) : "-"}
                                            </p>
                                            <p className="text-sm text-gray-800 py-1">
                                                <strong>Valid To:</strong> {consentDetails.requestedValidTo ? formatOnlyDate(consentDetails.requestedValidTo) : "-"}
                                            </p>
                                            <p className="text-sm text-gray-800 py-1">
                                                <strong>Expire Date Time:</strong> {consentDetails.requestedExpireDate ? formatDate(consentDetails.requestedExpireDate) : "-"}
                                            </p>
                                            <p className="text-sm text-gray-800 py-1">
                                                <strong>Denied Date Time:</strong> {consentDetails.deniedDateTime ? formatDate(consentDetails.deniedDateTime) : "-"}
                                            </p>
                                            <div>
                                                <strong className="text-sm text-gray-700">Requested HI Types:</strong>
                                                <div className="flex flex-wrap gap-2 mt-1">
                                                    {consentDetails.requestedHiTypes?.map((type, idx) => (
                                                        <span
                                                            key={idx}
                                                            className="px-2 py-1 bg-[#E6F4EA] text-[#0F766E] border border-[#0F766E] rounded-full text-xs font-medium"
                                                        >
                                                            {type}
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="flex justify-end mt-6">
                            <button
                                onClick={closeDetailsModal}
                                className="px-4 py-2 bg-[#0F766E] text-white rounded-md hover:bg-[#0D645E] text-sm"
                            >
                                Close
                            </button>
                        </div>
                    </Modal>
                )}

                <ToastContainer />
            </div>
        </>
    );
};

export default Viewdoctor;
